@let details = currentOffer();
@let modal = ticketSummaryModal();

@if (details) {
  <div>
    <div class="flex flex--space-between flex--middle">
      <h1
        class="pr-large-y font-heading-3 ms-clear nordic-blue-900-text text-icon-primary font-headline-small"
        [class.bold-type]="!isNewBrand()"
      >
        {{ 'ticketSelection.reviewFlights' | finLocalization }}
      </h1>
    </div>
    @for (boundSummary of boundSummary(); track boundSummary.bound.id) {
      <fin-flight-card
        class="block"
        [ngClass]="{
          'pr-xsmall-t': !$first,
        }"
        [attr.data-testid]="'pax-flight-review-bound-' + $index"
        [flightOrBound]="boundSummary.bound"
        [title]="
          'bookingSummary.boundTitle'
            | finLocalization
              : {
                  index: $index + 1,
                  departureCity: boundSummary.departureCity,
                  arrivalCity: boundSummary.arrivalCity,
                }
        "
        [locations]="details.locations"
        [passengers]="details.passengers"
        (viewDetails)="showTicketSummaryModal(boundSummary)"
        (modifyClicked)="returnToFlightSelection()"
      />
    }

    <fin-money-back-notification class="block mr-xsmall-t" />
  </div>

  <fcom-modal
    class="ticket-summary-modal"
    [title]="'ticketSelection.flightsAndBenefits.title' | finLocalization"
    [buttons]="ModalButtons.DONE"
    [open]="modal.open"
    (close)="closeModals()"
  >
    <fcom-tabs
      [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
      [nextButtonAriaLabel]="'carousel.next' | finLocalization"
      [layoutType]="TabLayoutType.IN_MODAL"
    >
      <fcom-tab [title]="'fareFamilyDetails.title' | finLocalization">
        <fin-fare-family-details
          class="block pr-medium"
          [fareFamilies]="[details.benefits[modal.bound?.fareFamilyCode]]"
          [hasWideBodyAircraft]="hasWideBodyFlight(modal.bound?.itinerary)"
        />
      </fcom-tab>
      <fcom-tab [title]="'itinerary.title' | finLocalization">
        <fin-itinerary-timeline
          class="block pr-medium"
          [locations]="details.locations"
          [bound]="modal.bound"
          [boundType]="modal.boundType"
          [isBookingFlow]="true"
        />
      </fcom-tab>
    </fcom-tabs>
  </fcom-modal>
}
